import { createContext, useContext } from 'react';

/** Where the Invoices screens live: `/invoices` in the full app, `/mobile/invoices` inside the mobile shell. */
export const InvoicesBaseContext = createContext('/invoices');

export function useInvoicesBase() {
  return useContext(InvoicesBaseContext);
}
